export default __webpack_public_path__ + "static/media/plusIcon.2f18bfa4.svg";